import { Component, OnInit, ViewChild } from '@angular/core';
import { CeqTableComponent } from '../../../../ceq/common/ceq-table/ceq-table.component';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { GridOptions } from 'ag-grid-community';
import { SettingsService } from '../../../../core/settings/settings.service';
import { TaxService } from '../../tax.service';
import { UserLogin } from '../../../common/models/UserLogin.Model';
import { ViewChildRendered } from '../../../common/renders/view-child-rendered';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {

  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;

  productName: string = '';
  user: UserLogin;
  pageSizes = [10, 50, 100, 1000, 'Todos'];
  pageSize: any = 100;
  productCode: string = '';
  searchTimeout: any;
  searchDelayDuration = 500;

  constructor(
    private settings: SettingsService,
    private taxService: TaxService
  ) {
    this.user = this.settings.getUser();
  }

  gridOptions: GridOptions = {
    context: this,
    frameworkComponents: {
      viewChildRendered: ViewChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { },
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  }

  columnDefs = [
    {
      headerName: 'Código',
      field: 'ProductCode',
      width: 100,
      cellClass: 'text-right',
      sortable: true,
      resizable: true
    }, {
      headerName: 'Producto',
      field: 'ProductDescription',
      width: 250,
      cellClass: 'align-start',
      sortable: true,
      resizable: true
    }, {
      headerName: 'Descripción Corta',
      field: 'ProductName',
      width: 200,
      cellClass: 'align-start',
      sortable: true,
      resizable: true
    },
    {
      headerName: 'Categoría',
      field: 'ProductType',
      width: 150,
      cellClass: 'align-start',
      sortable: true,
      resizable: true
    }, {
      headerName: 'Cupo',
      field: 'ProductConversion',
      width: 100,
      cellClass: 'text-right',
      resizable: true
    }, {
      headerName: 'Precio',
      field: 'ProductPrice',
      width: 100,
      cellClass: 'text-right',
      resizable: true,
      cellRenderer: (params: any) => params.value ? `$${params.value.toFixed(2)}` : '$0.00'
    }, {
      headerName: 'Peso',
      field: 'ProductWeight',
      width: 100,
      cellClass: 'text-right',
      resizable: true
    },
    {
      headerName: 'Ver',
      field: 'icon',
      width: 80,
      cellRenderer: 'viewChildRendered',
      colId: 'params',
      cellClass: 'text-center'
    }
  ];

  ngOnInit(): void { }

  gridEmiter(GridOptions: GridOptions) {
    this.gridOptions = GridOptions;
    this.getProduct();
  }

  async refresh(){
    this.getProduct();
  }

  view(row: any) {
    window.open('/tax/product/' + row.data.ProductCode, '_blank');
  }

  productCodeChange() {
    this.productName = ''; // Limpiar el otro filtro según tu lógica original
    if (this.productCode.length >= 4 || this.productCode.length === 0) {
      this.getProduct();
    } else {
      this.ceqGrid.data = [];
    }
  }

  productNameChange() {
    this.productCode = ''; // Limpiar el otro filtro según tu lógica original
    if (this.productName.length >= 5 || this.productName.length === 0) {
      this.getProduct();
    } else {
      this.ceqGrid.data = [];
    }
  }

  getProduct() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      const size = this.pageSize === 'Todos' ? 0 : this.pageSize;
      let params = [];
      
      if (this.productCode) params.push(`productCode=${this.productCode}`);
      if (this.productName) params.push(`productName=${this.productName}`);
      
      const queryString = params.length > 0 ? `?${params.join('&')}` : '';
      
      this.ceqGrid.endPoint = `product/${this.user.Org}/${size}${queryString}`;
      this.ceqGrid.refreshTable();
    }, this.searchDelayDuration);
  }

  onPageSizeChange(value: any) {
    this.pageSize = value;
    this.getProduct();
  }
}